export default function Positioning() {
  const features = [
    'No need to leave your current job',
    'No clinic startup costs',
    'No staff management',
    'Just you, your expertise, and your clients',
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="aspect-[4/3] bg-gradient-to-br from-[#D6E8F0] to-[#B8D4E8] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/0226d2f37308bdfb8b4c1f6be8521394.jpg"
                alt="Modern veterinarian workspace"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#D6E8F0]/40 to-transparent"></div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-6">
            <span className="text-xs font-semibold tracking-widest uppercase text-[#0F1F3D]">
              Modern Veterinary Platform
            </span>
            <h2 className="text-4xl lg:text-5xl font-serif text-gray-900 leading-tight">
              <span className="block">Not a Clinic Platform.</span>
              <span className="block mt-2">A Career Platform.</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Vetuvia is the infrastructure layer for your veterinary career — designed for individual veterinarians who want ownership and recurring revenue without traditional clinic overhead. Build your practice on your terms.
            </p>

            <div className="space-y-4 pt-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#4DB8D4] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-lg">{feature}</span>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <button className="px-8 py-4 bg-[#0F1F3D] text-white font-medium rounded-full hover:bg-[#1a2f52] transition-all whitespace-nowrap cursor-pointer">
                Learn More About Vetuvia
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}